function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Only allow http(s), same-origin paths, mailto, tel.
 * Blocks javascript:, protocol-relative //host, and other schemes.
 * Pass { allowData: true } for CMS file/image data URLs (not text/html).
 */
function safeHref(value, options = {}) {
  const href = String(value || "").trim();
  if (!href || href === "#") return "";
  if (/^\s*javascript:/i.test(href)) return "";
  if (href.startsWith("//")) return "";
  if (options.allowData && /^data:(image\/|application\/)/i.test(href)) return href;
  if (/^(https?:\/\/|\/|#|mailto:|tel:)/i.test(href)) return href;
  return "";
}

/** Allow only bare <span>…</span> wrappers from CMS titleHtml. */
function sanitizeTitleHtml(html) {
  const raw = String(html || "");
  if (!raw) return "";
  return raw
    .replace(/<(?!\/?span\b)[^>]*>/gi, "")
    .replace(/<\/?span\b[^>]*>/gi, (tag) => (/^<\/span/i.test(tag) ? "</span>" : "<span>"))
    .replace(/on\w+\s*=/gi, "");
}

function safeTitleHtml(html, title, buildTitleHtml) {
  const cleaned = sanitizeTitleHtml(html);
  if (cleaned && /<span>/.test(cleaned)) return cleaned;
  if (typeof buildTitleHtml === "function") return buildTitleHtml(title);
  return escapeHtml(title || "");
}

window.NMSanitize = {
  escapeHtml,
  safeHref,
  sanitizeTitleHtml,
  safeTitleHtml,
};

module.exports = {
  escapeHtml,
  safeHref,
  sanitizeTitleHtml,
  safeTitleHtml,
};
